/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Popover, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from '../AddDialog/addDialog.module.scss';
import deleteParameterIcon from '../../../../../../Assets/images/svg/dar_delete_parameter.svg';
import { removeDefaultStyles } from '../../../../../../Utils/buttonStyle';
import { v4 as uuidv4 } from 'uuid';

const EditDialog = ({
  isEditDialogOpen,
  setIsEditDialogOpen,
  selectedNode,
  setSelectedNode,
  editFromDialog,
  alignment,
  dealTypes
}) => {
  const renderNode = (node, level = 0) => {
    const indentation = `${20 * level}px`;
    const backgroundColor = level % 2 === 0 ? '#FFFFFF' : '#F1F5F8';

    return (
      <div
        key={node.id}
        style={{
          padding: `10px ${indentation}`,
          backgroundColor,
          borderRadius: '4px',
          marginBottom: '10px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            style={{
              fontFamily: 'Mukta-Medium',
              color: '#7A757F',
              fontSize: '12px',
            }}
          >
            {node.parameter || 'Unnamed Parameter'}
          </div>
          <button
            style={removeDefaultStyles}
            onClick={() => handleDeleteNode(node.id)}
          >
            <img
              src={deleteParameterIcon}
              alt="Delete"
              style={{ height: '16px', width: '16px' }}
            />
          </button>
        </div>
        <div
          style={{
            display: 'flex',
            gap: '10px',
          }}
        >
          {node.parameter === 'Deal Type' || node.parameter === 'Vertical' ? (
            <select
              style={{
                flex: 1,
                height: '33px',
                padding: '0px 10px',
                borderRadius: '4px',
                border: '1px solid #CAC4CF',
                backgroundColor: '#FFFFFF',
                minWidth: '100px',
              }}
              value={node.parameterLabel || ''}
              onChange={(e) => handleDropdownChange(e, node)}
            >
              <option value="">
                {node.parameter === 'Deal Type'
                  ? 'Select Deal Type'
                  : 'Select Vertical'}
              </option>
              {node.parameter === 'Deal Type' && (
                <>
                   {dealTypes.map(option => (
                  <option key={option.id} value={option.name}>{option.name}</option>
                ))}
                </>
              )}
              {node.parameter === 'Vertical' && (
                <>
                  <option value="Infra Mod">Infra Mod</option>
                  <option value="App Mod">App Mod</option>
                  <option value="Data Mod">Data Mod</option>
                </>
              )}
            </select>
          ) : (
            <>
              <input
                placeholder="Parameter Value From"
                style={{
                  flex: 1,
                  height: '33px',
                  padding: '0px 10px',
                  borderRadius: '4px',
                  border: '1px solid #CAC4CF',
                  minWidth: '80px',                  
                }}
                value={node.parameterValueFrom || ''}
                onChange={(e) =>
                  handleInputChange(e, node, 'parameterValueFrom')
                }
              />
              <input
                placeholder="Parameter Value To"
                style={{
                  flex: 1,
                  height: '33px',
                  padding: '0px 10px',
                  borderRadius: '4px',
                  border: '1px solid #CAC4CF',
                  minWidth: '80px',                  
                }}
                value={node.parameterValueTo || ''}
                onChange={(e) => handleInputChange(e, node, 'parameterValueTo')}
              />
            </>
          )}
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            style={removeDefaultStyles}
            onClick={(e) => openPopOver(e, node.id)}
          >
            <div
              style={{
                fontFamily: 'Mukta-SemiBold',
                color: '#6B5CE8',
                fontSize: '14px',
                cursor: 'pointer',
              }}
            >
              Add parameter
            </div>
          </button>
          <ExpandMoreIcon sx={{ color: '#6B5CE8' }} />
        </div>
        {node.children?.map((child) => renderNode(child, level + 1))}
      </div>
    );
  };

  const handleDropdownChange = (e, node) => {
    const updatedNode = { ...node, parameterLabel: e.target.value };
    updateNodeInParent(updatedNode);
  };

  const handleInputChange = (e, node, field) => {
    const updatedNode = { ...node, [field]: e.target.value };
    updatedNode.parameterLabel = `${updatedNode.parameterValueFrom || ''}-${
      updatedNode.parameterValueTo || ''
    }`;
    updateNodeInParent(updatedNode);
  };

  const updateNodeInParent = (updatedNode) => {
    const updatedSelectedNode = { ...selectedNode };
    updateNodeRecursively(updatedSelectedNode, updatedNode);
    setSelectedNode(updatedSelectedNode);
  };

  const updateNodeRecursively = (parentNode, updatedNode) => {
    if (parentNode.id === updatedNode.id) {
      Object.assign(parentNode, updatedNode);
    } else if (parentNode.children) {
      parentNode.children = parentNode.children.map((child) =>
        child.id === updatedNode.id
          ? updatedNode
          : updateNodeRecursively(child, updatedNode)
      );
    }
    return parentNode;
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentId, setCurrentId] = useState(null);

  const parameters = ['Deal Value', 'Margin', 'Deal Type'];

  const openPopOver = (e, id) => {
    setAnchorEl(e.currentTarget);
    setCurrentId(id);
  };

  const handleParameterSelect = async (parameter) => { 
    const newParameterNode = {
      id: uuidv4(),
      parameter: parameter,
      parameterLabel: '',
      parameterValueFrom: '',
      parameterValueTo: '',
      parameterValueId: 1,
      children: [],
    };

    const updatedSelectedNode = { ...selectedNode };
    addParameterToNode(updatedSelectedNode, currentId, newParameterNode);

    setSelectedNode(updatedSelectedNode);
    setAnchorEl(null);
  };
  const addParameterToNode = (parentNode, parentId, newParameterNode) => {
    
    if (parentNode.id === parentId) {
      if (!parentNode.children) {
        parentNode.children = [];
      }
      if (parentNode.details) {
        delete parentNode.details;
      }
      parentNode.children.push(newParameterNode);
    } else {
      parentNode.children?.forEach(child => addParameterToNode(child, parentId, newParameterNode));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteNode = (nodeId) => {
    const updatedSelectedNode = { ...selectedNode };

    const deleteNode = (parentNode, nodeId) => {
      if (parentNode.children) {
        parentNode.children = parentNode.children.filter(child => child.id !== nodeId);
        parentNode.children.forEach(child => deleteNode(child, nodeId));
      }
    };

    if (updatedSelectedNode.id === nodeId) {
      setSelectedNode(null);
    } else {
      deleteNode(updatedSelectedNode, nodeId);
      setSelectedNode(updatedSelectedNode);
    }
  };

  const details = {
    deal_type_id: 3,
    market: 'India',
    industry: 'banking',
    marketId: 7,
    vertical: 'App Mod',
    industryId: 7,
    verticalId: 49,
    firstApprover: '',
    secondApprover: '',
    thirdApprover: '',
    firstApproverId: 56,
    secondApproverId: 57,
    thirdApproverId: 58,
    isApprovalSerial: true,
  };

  const replaceEmptyChildrenWithDetails = (node) => {
    if (!node.children || node.children.length === 0) {
      node.details = { ...details, parameterValueId: 1 }; 
      delete node.children; 
    } else {
      node.children.forEach((child) => replaceEmptyChildrenWithDetails(child));
    }
  };

  const handleSave = () => {
    const updatedNode = { ...selectedNode };
    replaceEmptyChildrenWithDetails(updatedNode);
    editFromDialog(updatedNode);
    setIsEditDialogOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isEditDialogOpen}
        onClose={() => setIsEditDialogOpen(false)}
        fullWidth
        PaperProps={{
          style: {
            width: '696px',
            maxHeight: '400px',
          },
        }}
      >
        <header className={styles['header']}>
          Edit {alignment}
        </header>
        <DialogContent>
        {selectedNode && renderNode(selectedNode)}
        </DialogContent>
        <footer className={styles['footer']}>
          <button
            onClick={() => setIsEditDialogOpen(false)}
            className={styles['cancel-button']}
          >
            Cancel
          </button>
          <button className={styles['save-button']} onClick={handleSave}>
            Save
          </button>
        </footer>
      </Dialog>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {parameters.map((parameter) => (
          <Button
            key={parameter}
            onClick={() => handleParameterSelect(parameter)}
            sx={{
              fontFamily: 'Mukta-Regular',
              color: '#49454E',
              '&:hover': {
                backgroundColor: '#ECEDF4',
                color: '#6B5CE8',
              },
            }}
            style={{ display: 'block', marginBottom: '5px' }}
          >
            {parameter}
          </Button>
        ))}
      </Popover>
    </div>
  );
};

EditDialog.propTypes = {
  isEditDialogOpen: PropTypes.bool.isRequired,
  setIsEditDialogOpen: PropTypes.func.isRequired,
  selectedNode: PropTypes.shape({
    id: PropTypes.string.isRequired,
    parameter: PropTypes.string,
    parameterLabel: PropTypes.string,
    parameterValueFrom: PropTypes.string,
    parameterValueTo: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  setSelectedNode: PropTypes.func.isRequired,
  editFromDialog: PropTypes.func.isRequired,
  alignment: PropTypes.string.isRequired,
  dealTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default EditDialog;